import { Component, Inject, OnInit, OnDestroy, Injectable } from '@angular/core';
import { DwAction, DwActionType, DwButtonType, DwActionHandler, DwMdFormActionState,
         DwActionResult, DwConfigServiceToken, DwEventService, DwConfigService, DwOrmDataService,
         DwMetaDataFormApi, DwMetaDataFormStateService } from '@devwareapps/devware-cap';
import { AdminManagerService } from '../../../features/admin/services/admin-manager.service';
import { AppMetaDataItemNames, ProcessorConfigEntity } from '../../../meta-data/app-meta-data.service';
import { Observable, of } from "rxjs";
import { PaymentsRepositoryService } from "src/app/features/payments/services/payments-repository.service";
import { HttpClient } from "@angular/common/http";
import { map, mergeMap } from 'rxjs/operators';
import { AviatorUser } from '../../shared/models/aviator-user.model';

@DwAction({
    keyName: 'resetConnectedAccount',
    display: 'Reset Profit Sharing',
    actionType: DwActionType.formAction,
    isGlobal: false,
    parentItemName: [AppMetaDataItemNames.FlightSchool,AppMetaDataItemNames.ProcessorConfig],
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Undo Setup',
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-primary',
        iconClass: 'fa fa-undo',
    },
    defaultConfirmConfig: {
        showConfirmDialog: true,
        title: 'Undo profit sharing setup?',
        message: 'This will disconnect the current payout account and restart profit sharing setup.',
    },
})
@Injectable()
export class ResetProfitSharingActionService implements DwActionHandler {
    paymentsApi: string;
    formApi: DwMetaDataFormApi;
    accountReady: boolean= false;
    aviatorUser: AviatorUser;
    processorConfig: ProcessorConfigEntity = undefined;
    constructor(
        private http: HttpClient,
        private paymentsRepoSvc: PaymentsRepositoryService,
        private adminManagerService: AdminManagerService,       
        private dwEventService: DwEventService,
        @Inject(DwConfigServiceToken) private configService: DwConfigService) 
    { 
        this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
    }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        this.formApi = actionState.formApi;
        return this.http.get(`${this.paymentsApi}/profit-sharing-reset`)
                    .pipe(mergeMap(r => {
                        const success = (r as any).success;
                        if (success){
                            this.formApi.resetForm();
                        }
                        return of({ success });
                    }));
    }
}
